import React from 'react';

import { CASINO_SETTINGS_GAMES, CASINO_SETTINGS_LOGO, CASINO_SETTINGS_TEMPLATE } from '../Helpers/CrmUrls';

import { SettingItem } from './SettingItem';
import Settings from './Settings';

function CasinoSettingsList() {
    const availableSettings: SettingItem[] = [
        {
            name: 'Games',
            icon: 'mdi mdi-gamepad-variant',
            path: CASINO_SETTINGS_GAMES,
            description: 'Customize games view',
        },
        {
            name: 'Logo',
            icon: 'mdi mdi-file-image',
            path: CASINO_SETTINGS_LOGO,
            description: 'Set custom logo for casino',
        },
        {
            name: 'Template',
            icon: 'mdi mdi-view-dashboard',
            path: CASINO_SETTINGS_TEMPLATE,
            description: 'Customize casino template',
        },
    ];

    return <Settings availableSettings={availableSettings} />;
}

export default CasinoSettingsList;
